// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Chat: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M37.67,0.17H4.33c-2.29,0-4.15,1.88-4.15,4.17l-0.02,37.5L8.5,33.5h29.17
	c2.29,0,4.17-1.88,4.17-4.17v-25C41.83,2.04,39.96,0.17,37.67,0.17z M25.17,25.17H8.5V21h16.67V25.17z M33.5,18.92h-25v-4.17h25
	V18.92z M33.5,12.67h-25V8.5h25V12.67z"/>
</svg>;
};

export default React.memo(Chat);
